import script from "./HeaderTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTemplate.vue?vue&type=style&index=0&id=9a5392f0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a5392f0"]])

export default __exports__